import { rest } from 'msw';
import { getEnv } from 'util/getEnv';
import { salesScanToPay } from './fixtures/wallet-service.fixture';

export const getSalesSummaryScanToPayMock = fn =>
  rest.get(
    `${getEnv(
      'REACT_APP_ADMIN_API_URL',
    )}/incentivio-wallet/scan-to-pay/sales-summary`,
    fn,
  );

export const handlers = () => [
  getSalesSummaryScanToPayMock((_req, res, ctx) => {
    return res(ctx.json(salesScanToPay));
  }),
];
